import styles from './ModalHeader.scss';

import cx from 'classnames';
import React from 'react';
import { WithTranslation, withTranslation } from 'react-i18next';

import { MaterialIcon } from 'src/components/MaterialIcon/MaterialIcon';

export interface IModalHeader extends React.AllHTMLAttributes<HTMLElement>, WithTranslation {
  heading?: string;
  headingId?: string;
  subheading?: string;
  hasDivider?: boolean;
  onCloseButtonClick?: React.MouseEventHandler<HTMLButtonElement>;
}

const ModalHeader: React.FC<IModalHeader> = ({
  heading,
  headingId,
  subheading,
  hasDivider,
  onCloseButtonClick,
  className,
  children,
  i18n,
  t,
  tReady,
  ...props
}) => (
  <header
    className={cx(styles.modalHeader, className, {
      [styles.modalHeaderHasDivider]: hasDivider,
    })}
    {...props}
  >
    {onCloseButtonClick && (
      <button className={styles.closeButton} onClick={onCloseButtonClick} title={t('close')} data-test="close-button">
        <MaterialIcon icon="clear" />
      </button>
    )}
    <div className={styles.textWrapper}>
      {heading && <h2 id={headingId} data-test="modal-heading">{heading}</h2>}
      {subheading && <h5>{subheading}</h5>}
      {children}
    </div>
  </header>
);

const Translated = withTranslation()(ModalHeader);

export { Translated as ModalHeader };
